export type AdminCacheEntry<T> = {
  cachedAt: number;
  data: T;
};

const ADMIN_CACHE_PREFIX = "adm.ui.cache.v1";

// 사용자/페이지/쿼리 조합으로 세션 캐시 키를 만든다.
export function buildCacheKey(uid: string, pageId: string, queryKey = "default") {
  return `${ADMIN_CACHE_PREFIX}:${uid}:${pageId}:${queryKey || "default"}`;
}

// 특정 사용자+페이지 캐시를 일괄 무효화할 때 사용할 prefix를 만든다.
export function buildPagePrefix(uid: string, pageId: string) {
  return `${ADMIN_CACHE_PREFIX}:${uid}:${pageId}:`;
}

// TTL 안에 있는 세션 캐시만 읽어 화면 워밍 데이터를 제공한다.
export function getFreshCache<T>(key: string, ttlMs: number): AdminCacheEntry<T> | null {
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as AdminCacheEntry<T>;
    if (!parsed || typeof parsed !== "object") return null;
    if (typeof parsed.cachedAt !== "number" || !Number.isFinite(parsed.cachedAt)) return null;
    if (Date.now() - parsed.cachedAt > ttlMs) return null;
    return parsed;
  } catch {
    return null;
  }
}

// 캐시 엔트리를 현재 시각과 함께 sessionStorage에 저장한다.
export function setCache<T>(key: string, data: T) {
  try {
    const payload: AdminCacheEntry<T> = {
      cachedAt: Date.now(),
      data,
    };
    sessionStorage.setItem(key, JSON.stringify(payload));
  } catch {
    // no-op
  }
}

// prefix로 시작하는 관리자 캐시 키를 찾아 일괄 제거한다.
export function invalidateByPrefix(prefix: string) {
  try {
    const targets: string[] = [];
    for (let index = 0; index < sessionStorage.length; index += 1) {
      const key = sessionStorage.key(index);
      if (!key) continue;
      if (key.startsWith(prefix)) targets.push(key);
    }
    targets.forEach((key) => sessionStorage.removeItem(key));
  } catch {
    // no-op
  }
}
